import type { SliceI18nManifest } from '@/shared/lib/vsa';
import cs from './locales/cs.json';
import en from './locales/en.json';

const NS = 'venua-planner';

export const venuaPlannerI18nManifest: SliceI18nManifest = {
  owner: 'features/venua-planner',
  namespaces: [NS],
  resources: {
    cs: {
      [NS]: cs,
    },
    en: {
      [NS]: en,
    },
  },
};
